import React from 'react';
import { WalkerHomePhotos, WalkerOfferedServicesResponse, WalkerReviews, WalkerServiceAddons, WalkerServiceCategoryGallery, WalkerSpecialtiesV6 } from '../../../../types/api';
import WalkerServiceCollapsible from './WalkerCollapsible/WalkerServiceCollapsible';
import { WalkerServicesRates } from './WalkerServicesRates';
import { WalkerService } from './WalkerCollapsible/WalkerService';
import { WalkerServiceCollapsibleTitle } from './WalkerCollapsible/WalkerServiceCollapsibleTitle';
import { Box, BoxProps } from '../../../../wag-react/next-components/box';
type Props = {
  servicesOffered: WalkerOfferedServicesResponse;
  specialties: WalkerSpecialtiesV6;
  homePhotos: WalkerHomePhotos;
  serviceAddons: WalkerServiceAddons;
  reviews: WalkerReviews;
  servicesGallery: {
    items: WalkerServiceCategoryGallery['items'];
    serviceCategory: string;
  }[];
  containerProps?: BoxProps;
};
export const WalkerServices = ({
  servicesOffered,
  specialties,
  serviceAddons,
  reviews,
  servicesGallery,
  containerProps
}: Props) => {
  const servicesOfferedItems = servicesOffered?.items || [];
  return <Box {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerServices" data-sentry-source-file="index.tsx">
      <WalkerServicesRates rates={servicesOfferedItems.map(item => ({
      serviceName: item.serviceCategory,
      minPrice: item.price.min
    }))} data-sentry-element="WalkerServicesRates" data-sentry-source-file="index.tsx" />
      <Box py={[2, 3]} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {servicesOfferedItems.map(walkerService => <WalkerServiceCollapsible key={walkerService.serviceCategory} title={<WalkerServiceCollapsibleTitle serviceCategoryName={walkerService.serviceCategory} minPrice={walkerService.price.min} />} content={<WalkerService walkerService={walkerService} specialties={specialties} images={servicesGallery.find(serviceGallery => serviceGallery.serviceCategory === walkerService.serviceCategory)?.items} serviceAddons={serviceAddons} reviews={reviews?.items.filter(review => review.serviceType === walkerService.serviceCategory)} />} />)}
      </Box>
    </Box>;
};